import { font, uTextEllipsis } from '@approvalmax/ui';
import { Flex } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    flex-flow: column;
    user-select: none;
`;

export const Description = styled.div`
    flex: none;
`;

export const ListHeader = styled.div`
    ${font(13, '#30373d')};
    line-height: 48px;
    ${uTextEllipsis};
    cursor: pointer;
    font-weight: 600;
`;

export const List = styled.div`
    margin: 20px 0;
`;

export const PaddedGridHeader = styled(Flex)`
    padding: 0 10px;
    background-color: #f9f9f9;
`;
